import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { StickyBar } from './components/StickyBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { AgitationSection } from './components/AgitationSection';
import { OfferSection } from './components/OfferSection';
import { PriceAnchorSection } from './components/PriceAnchorSection';
import { IndividualProducts } from './components/IndividualProducts';
import { WhoIsItFor } from './components/WhoIsItFor';
import { SocialProofSection } from './components/SocialProofSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
const KIT_URL = 'https://digital-solvex-ar.myshopify.com/cart/48681186394369:1';
const PIXEL_IDS = ['2344220106105382', '1663859418293777'];
export function App() {
  const [showFloat, setShowFloat] = useState(false);

  // Meta Pixel
  useEffect(() => {
    const w = window as any;
    if (!w.fbq) {
      const n: any = w.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
    }
    if (!document.querySelector('script[src*="fbevents.js"]')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    PIXEL_IDS.forEach(id => {
      if (!document.querySelector(`img[src*="id=${id}"]`)) {
        const img = document.createElement('img');
        img.height = 1;
        img.width = 1;
        img.style.display = 'none';
        img.src = `https://www.facebook.com/tr?id=${id}&ev=PageView&noscript=1`;
        document.body.appendChild(img);
      }
    });
    PIXEL_IDS.forEach(id => w.fbq('init', id));
    w.fbq('track', 'PageView');
  }, []);
  useEffect(() => {
    const fn = () => setShowFloat(window.scrollY > 700);
    window.addEventListener('scroll', fn, {
      passive: true
    });
    return () => window.removeEventListener('scroll', fn);
  }, []);
  return <div className="w-full min-h-screen bg-navy font-body overflow-x-hidden" data-id="element-0">
      <StickyBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <AgitationSection data-id="element-4" />
      <OfferSection data-id="element-5" />
      <PriceAnchorSection data-id="element-6" />
      <IndividualProducts data-id="element-7" />
      <WhoIsItFor data-id="element-8" />
      <SocialProofSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />
      <WhatsAppButton data-id="element-13" />

      {/* Mobile sticky CTA */}
      <AnimatePresence data-id="element-14">
        {showFloat && <motion.div initial={{
        y: 90,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 90,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-navy-dark/95 backdrop-blur-sm border-t border-gold/20 p-3" style={{
        paddingBottom: 'calc(0.75rem + env(safe-area-inset-bottom))'
      }} data-id="element-15">
            <a href={KIT_URL} className="btn-gold block w-full text-center py-3.5 rounded-xl font-extrabold text-sm" data-id="element-16">
              Kit Completo — $62.900 →
            </a>
          </motion.div>}
      </AnimatePresence>
    </div>;
}